<template>
  <div class="z-tabs" :class="['z-tabs--' + effect]" @click="recordCursorPosition">
    <div
      class="z-tabs-cursor"
      :style="{left: cursorPosition + 'px'}"
      @click.stop
      v-if="currentCategory >= 0"
    >{{ options[currentCategory][label] }}</div>
    <div
      class="z-tabs-item"
      v-for="(item, index) in options.slice(0, maxLength)"
      :key="item[label]"
      @click="event => tabChanged(event, index)"
    >{{ item[label] }}</div>
    <el-dropdown v-if="options.length > maxLength" @command="handleCommand">
      <div class="z-tabs-more" @click.stop>
        <i class="el-icon-more" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) in options.slice(maxLength, options.length)"
          :key="item[label]"
          :command="maxLength + index"
        >{{ item[label] }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "ZeroTabs",
  props: {
    effect: { type: String, default: "dark" },
    label: { type: String, default: "label" },
    options: { type: Array, required: true },
    maxLength: { type: Number, default: 7 }
  },
  data() {
    return {
      currentCategory: 0,
      cursorPosition: 0
    };
  },
  methods: {
    // 记录鼠标点击位置
    recordCursorPosition(event) {
      this.cursorPosition = event.layerX - event.offsetX;
    },
    // 切换标签
    tabChanged(event, index) {
      this.currentCategory = index;
      this.$emit("change", index);
    },
    //
    handleCommand(index) {
      this.currentCategory = -1;
      this.$emit("change", index);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
.z-tabs {
  display: flex;
  border-radius: $radius-button;
  position: relative;
  &--light {
    color: $color-title;
    background-color: rgba($color: $color-primary, $alpha: 0.1);
    .z-tabs-cursor {
      color: #fff;
    }
    .z-tabs-item {
      color: $color-text;
      // &:hover {
      //   color: #fff;
      // }
    }
  }
  &--dark {
    color: #fff;
    background-color: rgba($color: #fff, $alpha: 0.1);
  }
  &-item,
  &-cursor,
  &-more {
    color: #fff;
    text-align: center;
    line-height: 32px;
    font-size: 12px;
    border-radius: $radius-button;
    transition: $transition-primary;
    user-select: none;
    cursor: pointer;
  }
  &-item,
  &-cursor {
    padding: 0 24px;
  }
  // &-item {
  //   &:hover {
  //     background-color: rgba($color: $color-primary, $alpha: 0.4);
  //   }
  // }
  &-cursor {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: $color-primary;
  }
  &-more {
    width: 50px;
  }
}
</style>